module.exports = __webpack_public_path__ + "img/calendar.a267506.svg";